import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';

@Component({
  selector: 'app-coachmark-efficiency-tips',
  templateUrl: './coachmark-efficiency-tips.component.html',
  styleUrls: ['./coachmark-efficiency-tips.component.scss']
})
export class CoachmarkEfficiencyTipsComponent implements OnInit {
  show: boolean;
  constructor(private sessionStateService: SessionStateService) { }

  ngOnInit() {
    this.moveMsg();
  }

  gotIt() {
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(this.sessionStateService.getCoachMarkIndividualState().set('efficiency-tips', false));
  }

  moveMsg() {
    const waitRendering =  setInterval( () => {
       const elem = document.getElementsByClassName('radioBtns')[0];
       if (elem) {
         const elemPosition: ClientRect = elem.getBoundingClientRect();
           if ($('#coachmarkEfficiencyTips').length === 1) {
             $('#coachmarkEfficiencyTips').css('left', elemPosition.left )
               .css('top', elemPosition.top + window.scrollY - 100)
               .css('display', 'block');
           }
           this.show = true;
           clearInterval(waitRendering);
       }
     }, 2000);
   }

   getImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
        return '../assets/img/icons/coachmark-efficiency-tips-es.svg';
      case 'PT':
        return '../assets/img/icons/coachmark-efficiency-tips-pt.svg';
      case 'EN':
        return '../assets/img/icons/coachmark-efficiency-tips-en.svg';
      default:
        return '../assets/img/icons/coachmark-efficiency-tips-pt.svg';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-efficiency-tips/coachmark-efficiency-tips.component.ts